import { motion } from "framer-motion";
import { IMAGES } from "@/data";

export default function WhaleShark({ className = "", opacity = 0.22, flip = false, testid = "whale-shark" }) {
    return (
        <motion.img
            src={IMAGES.whale}
            alt=""
            aria-hidden="true"
            data-testid={testid}
            animate={{ y: [0, -16, 0] }}
            transition={{ repeat: Infinity, duration: 9, ease: "easeInOut" }}
            className={`pointer-events-none absolute mix-blend-screen select-none ${flip ? "-scale-x-100" : ""} ${className}`}
            style={{ opacity }}
        />
    );
}
